<template>

  <v-row dense>
    <v-col>

      <v-row dense align="center">

        <v-col cols="auto">
          <v-switch
            v-model="isActiveInternal"
            dense
            class="v-input--reverse font-weight-bold"
            :disabled="disabled"
            @input="handleChange"
          >
            <template #label>
              <span class="text-h5 gray--text">
                Longe
              </span>
            </template>
          </v-switch>
        </v-col>
      </v-row>


      <v-row dense>
        <v-col>
          <v-row>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Esférico

            </v-col>
          </v-row>

          <v-row dense>
            <v-col>

              <v-combobox
                :disabled="!isActive || disabled"
                v-model="sphericalRightEye"
                placeholder=" "
                label="Olho direito"
                dense
                outlined
                hide-details
                :items="sphericalFacilitators"
                background-color="white"
                :menu-props="{ auto: true, maxHeight: 304 }"
                @input="handleChange"
                @change="updateParent"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                :disabled="!isActive || disabled"
                v-model="sphericalLeftEye"
                placeholder=" "
                label="Olho esquerdo"
                dense
                outlined
                hide-details
                :items="sphericalFacilitators"
                background-color="white"
                :menu-props="{ auto: true, maxHeight: 304 }"
                @input="handleChange"
                @change="updateParent"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Cilíndrico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                :disabled="!isActive || disabled"
                v-model="cylindricalRightEye"
                placeholder=" "
                label="Olho direito"
                dense
                outlined
                hide-details
                :items="cylindricalFacilitators"
                background-color="white"
                @input="handleChange"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                :disabled="!isActive || disabled"
                v-model="cylindricalLeftEye"
                placeholder=" "
                label="Olho esquerdo"
                dense
                outlined
                hide-details
                :items="cylindricalFacilitators"
                background-color="white"
                @input="handleChange"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Eixo
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                :disabled="!isActive || disabled"
                v-model="axisRightEye"
                placeholder=" "
                label="Olho direito"
                dense
                outlined
                hide-details
                :items="axisFacilitators"
                suffix="°"
                background-color="white"
                @input="handleChange"
              />
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                :disabled="!isActive || disabled"
                v-model="axisLeftEye"
                placeholder=" "
                label="Olho esquerdo"
                dense
                outlined
                hide-details
                :items="axisFacilitators"
                suffix="°"
                background-color="white"
                @input="handleChange"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import SAVE_DISTANCE_GLASSES from "@/graphql/glasses_prescription/save_distance_glasses.gql";

  export default {
    name: "GlassesPrescriptionFormDistanceGlasses",
    props: {
      attendance: Object,
      isActive: Boolean,
      glassesPrescriptionId: String,
      distanceGlasses: Object,
      refreshGlassesPrescription: Function,
      facilitators: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
     handleChange: Function,
    },
    data() {
      return {
        sphericalLeftEye: "Em branco",
        sphericalRightEye: "Em branco",
        cylindricalLeftEye: "",
        cylindricalRightEye: "",
        axisLeftEye: "",
        axisRightEye: "",
      };
    },
    created: function() {
      this.debouncedSaveDistanceGlasses = this.lodash.debounce(this.saveDistanceGlasses, 900000);
    },
    mounted() {
      this.loadDistanceGlasses();
      this.updateParent()
    },
    watch: {
      distanceGlasses() {
        this.loadDistanceGlasses();
      },
    },
    computed: {
      isActiveInternal: {
        set(e) {
          this.$emit("distance-glasses", e);
        },
        get() {
          return this.isActive;
        },
      },
      sphericalFacilitators() {
        let facilitator = this.lodash.find(this.facilitators, { facilitatorType: "spherical" });
        if (facilitator) {
          return facilitator.values;
        }

        return [];
      },
      cylindricalFacilitators() {
        let facilitator = this.lodash.find(this.facilitators, {
          facilitatorType: "cylindrical",
        });
        if (facilitator) {
          return facilitator.values;
        }

        return [];
      },
      axisFacilitators() {
        let facilitator = this.lodash.find(this.facilitators, { facilitatorType: "axis" });
        if (facilitator) {
          return facilitator.values;
        }

        return [];
      },
    },
    methods: {
      updateParent() {
        this.$emit('update-value', this.sphericalRightEye, this.sphericalLeftEye);
      },

      loadDistanceGlasses() {
        if (this.distanceGlasses) {
          this.sphericalLeftEye = this.distanceGlasses.sphericalLeftEye;
          this.sphericalRightEye = this.distanceGlasses.sphericalRightEye;
          this.cylindricalLeftEye = this.distanceGlasses.cylindricalLeftEye;
          this.cylindricalRightEye = this.distanceGlasses.cylindricalRightEye;
          this.axisLeftEye = this.distanceGlasses.axisLeftEye;
          this.axisRightEye = this.distanceGlasses.axisRightEye;
        }
      },
      async saveDistanceGlasses() {
        if (this.disabled) return;
        try {
          await this.apolloMutate({
          mutation: SAVE_DISTANCE_GLASSES,
          variables: {
            glassesPrescriptionId: this.glassesPrescriptionId,
            sphericalLeftEye: this.sphericalLeftEye,
            sphericalRightEye: this.sphericalRightEye,
            cylindricalLeftEye: this.cylindricalLeftEye,
            cylindricalRightEye: this.cylindricalRightEye,
            axisLeftEye: this.axisLeftEye,
            axisRightEye: this.axisRightEye,
          },
        })
        } catch (error) {
          console.error('Erro ao salvar:', error);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
